module.exports = __webpack_public_path__ + "static/img/7690_phase_function_Paper_Points.f78ea6a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/7690_phase_function_Paper_Points.png
// module id = BgQn
// module chunks = 0